import * as React from 'react';
import { memo } from 'react';

import { HeartbeatMapDispatchToPropsType, HeartbeatMapStateToPropsType } from 'containers/helper/Heartbeat';
import { areNotificationsDisabled } from 'defs/flags';
import appConfig from 'helper/mapBackendConfig';
import Job, { IntervalJob } from 'lib/Job';

export const HEARTBEAT_INTERVAL: number = appConfig.env.heartbeatInterval * 1000 || 10 * 1000;
export const ID = 'heartbeat';

export type HeartbeatPropsType = HeartbeatMapStateToPropsType & HeartbeatMapDispatchToPropsType;

let heartbeatJobInstance: Job;

/*
 * Heartbeat connection handler
 * @see PULSWM-2936
 * @author Jan Biasi <jan.biasi@namics.com>
 * @param {HeartBeatPropsType} props
 */
export class Heartbeat extends React.Component<HeartbeatPropsType> {
	public static displayName = 'Heartbeat';

	public componentDidMount() {
		this.update();
	}

	public componentDidUpdate() {
		this.update();
	}

	public update(): void {
		const { doRequestAsyncEvents, isAuthenticated } = this.props;

		if (areNotificationsDisabled) {
			return;
		}

		if (!isAuthenticated) {
			return;
		}

		doRequestAsyncEvents();

		if (!heartbeatJobInstance) {
			heartbeatJobInstance = new IntervalJob(ID, doRequestAsyncEvents, HEARTBEAT_INTERVAL);
		}

		heartbeatJobInstance.run();
	}

	public render() {
		return null;
	}
}

export default memo(Heartbeat);
